module.exports = __webpack_public_path__ + "img/flat_pocket.0431693d.png";